import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { formatCurrency } from '../../helpers/currencyHelper'
import { getItemValue } from '../../helpers/itemHelper'
import { CurrencyCode } from '../../types/API'
import {
  GiftItemStatus,
  IColorTheme,
  ITicketPrice,
} from '../../types/itemTypes'
import { getTicketPrice } from '../helpers/itemPrice'
import Individuals from './Individuals'

const Styles = styled.div`
  margin-top: auto;
  font-size: 15px;
  display: flex;
  flex-direction: column;
`
const OriginalPrice = styled.s`
  color: ${(props): string => props.theme.colourPriceText};
  opacity: 0.7;
  font-weight: normal;
  height: 16px;
`
const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .item-price {
    font-weight: bold;
    color: ${(props): string => props.theme.colourPriceText};
  }
`
interface IPriceProps {
  value: string
  originalPrice?: number | null
  currencyCode: CurrencyCode
  maxIndividuals?: number
  individuals: number
  setIndividuals: (individuals: number) => void
  colorTheme: IColorTheme
  prices: ITicketPrice[] | undefined
}
export default function Price({
  value,
  originalPrice,
  currencyCode,
  maxIndividuals,
  individuals,
  setIndividuals,
  colorTheme,
  prices,
}: IPriceProps): ReactElement {
  const isMonetary = value.includes(',')
  const price = isMonetary ? value : (Number(value) * individuals).toString()
  const hasPrices = prices && prices.length > 0

  // If Ticket has multiple Prices
  if (hasPrices) {
    const activePrices = [...(prices || [])].filter(
      ({ status }) => status === GiftItemStatus.Published,
    )

    return (
      <Styles>
        <PriceRow theme={colorTheme}>
          <div className="item-price">
            {getTicketPrice(activePrices, currencyCode)}
          </div>
        </PriceRow>
      </Styles>
    )
  }

  const originalPriceHasDecimals = originalPrice
    ? originalPrice % 1 !== 0
    : false

  // If Ticket does not have multiple Prices
  return (
    <Styles>
      {/* TODO create two helper functions (or one), for string
      and number, that return exactly the correct currency format */}
      {originalPrice && (
        <OriginalPrice theme={colorTheme}>
          {formatCurrency(
            originalPrice,
            currencyCode,
            !originalPriceHasDecimals,
          )}
        </OriginalPrice>
      )}
      <PriceRow theme={colorTheme}>
        <div className="item-price">{getItemValue(price, currencyCode)}</div>
        {maxIndividuals && maxIndividuals > 1 && (
          <Individuals
            maxIndividuals={maxIndividuals}
            individuals={individuals}
            setIndividuals={setIndividuals}
            colorTheme={colorTheme}
          />
        )}
      </PriceRow>
    </Styles>
  )
}
